import React from 'react';

/**
 * Input - Dark-aware text input primitive.
 *
 * The single source of truth for input styling across TradesMatePro apps.
 * Works in both light and dark mode (darkMode: 'class'). Any `className`
 * passed in is appended AFTER the base classes, so callers can override
 * individual utilities (e.g. width, rounding) without losing the dark bg.
 *
 * All native props (value, onChange, name, id, type, placeholder, disabled,
 * required, ref, ...) pass straight through to the underlying <input>.
 *
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes (override base)
 */
const BASE =
  'w-full px-3 py-2 rounded-lg border transition-colors ' +
  'bg-white text-gray-900 border-gray-300 placeholder-gray-400 ' +
  'dark:bg-slate-800 dark:text-slate-100 dark:border-slate-600 dark:placeholder-slate-400 ' +
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ' +
  'disabled:opacity-60 disabled:cursor-not-allowed';

const Input = React.forwardRef(({ className = '', ...props }, ref) => (
  <input ref={ref} className={`${BASE} ${className}`.trim()} {...props} />
));

Input.displayName = 'Input';

export default Input;
